import React from "react";
import { Card, CardContent, Tooltip, IconButton } from "@mui/material";
import { ArrowUp, ArrowDown, Info } from "lucide-react";
import "./StatCard.scss"; // Import the SCSS file


const today = new Date();

const day = today.getDate();
const month = today.toLocaleString('en-US', { month: 'short' }); // "Jun"
const year = today.getFullYear();

const formatted = `${day}-${month} ${year}`;

const StatCard = ({ title, value, change, chart, tooltip }) => {
  return (
    <Card className="stat-card">
      <CardContent  className="card-content">
        <div className="card-header">
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <p className="title">{title}</p>
              {tooltip && (
                <Tooltip 
                  title={tooltip}
                  placement="top"
                  arrow
                  sx={{
                    '& .MuiTooltip-tooltip': {
                      backgroundColor: '#0000a0',
                      color: 'white',
                      fontSize: '12px',
                      padding: '8px 12px',
                      borderRadius: '6px',
                      maxWidth: '300px',
                      textAlign: 'center'
                    }
                  }}
                >
                  <IconButton 
                    size="small" 
                    sx={{ 
                      padding: '2px',
                      color: '#0000a0',
                      '&:hover': {
                        backgroundColor: '#f0f8ff'
                      }
                    }}
                  >
                    <Info size={16} />
                  </IconButton>
                </Tooltip>
              )}
            </div>
            <h3 className="value">{value}</h3>
          </div>
          <div className="chart-container">{chart}</div>
        </div>

        <div className={`change-indicator`}>
          
            <>
              {/* <ArrowUp className="arrow-icon" /> */}

              <span className="bg-gray-200 rounded p-2">{formatted}</span>
            </>

        </div>
      </CardContent>
    </Card>
  );
};

export default StatCard;
